/**
 * Labels is the translated word for each breadcrumb item
 */
export enum BreadcrumbLabels {
  Dashboard = 'Dashboard',

  Shipments = 'Shipments',
  Shipment = 'Shipment',
  BulkShipments = 'BulkShipments',

  Users = 'Users',
  UsersView = 'User',
  UsersAdd = 'AddUser',

  Receivers = 'ManageReceivers',
  ReceiversView = 'Receiver',
  ReceiversAdd = 'AddReceiver',

  CustomersMyCustomers = 'MyCustomers',
  CustomersView = 'Customer',
  MyWallet = 'MyWallet',
  CustomersAdd = 'AddCustomer',
  CustomersVerify = 'VerifyCustomer',
  CustomersSupport = 'CustomersSupport',
  BusinessUnits = 'BusinessUnits',

  Invoices = 'Invoices',
  InvoicesView = 'Invoice',
  InvoicesAdd = 'AddInvoice',

  Providers = 'Providers',
  ProvidersView = 'Provider',
  ProvidersAdd = 'AddProvider',
  ProvidersAddBulk = 'AddBulk',
  ProvidersRequest = 'Request',

  Drivers = 'Drivers',
  DriversView = 'Driver',
  DriversAdd = 'AddDriver',

  Trucks = 'Trucks',
  TrucksRented = 'RentedTrucks',
  TrucksView = 'Truck',
  TrucksAdd = 'AddTruck',

  TrailersView = 'Trailer',
  TrailersAdd = 'AddTrailer',

  TripPlanning = 'TripPlanning',
  TripPlanningRegularTrucks = 'RegularTrucks',

  LiveTracking = 'LiveTracking',
  Reports = 'Reports',
  TransportationPayments = 'TransportationPayments',
  Orders = 'Orders',

  // Manage
  Settings = 'Settings',
  PreviewOrders = 'PreviewOrders',

  Contracts = 'Contracts',
  ContractsView = 'ContractsView',
  ContractsAdd = 'ContractsAdd',
  ContractsEdit = 'ContractsEdit',
  ContractsTradeLanesAdd = 'ContractsTradeLanesAdd',
  ContractsTradeLanesEdit = 'ContractsTradeLanesEdit',

  Tickets = 'Tickets',
  SupportAddTicket = 'AddTicket',

  Transactions = 'Transactions',
}
